module.exports = __webpack_public_path__ + "img/resources.5a9c4856.svg";